import { defaultOpts } from "./fetch";

import {
  attachment_finalize_path,
  attachment_finalize_logo_path
} from '~/routes';

// Build the request body for finalising an upload made using Uppy to Tus server. I.e. /files endpoints
// file: file as received from uppy on 'upload-success'
// uploadResponse: response received from uppy on 'upload-success'
// permissions: permissions one should have to access the file. The se are confirmed at server 
export const finalizeUpload = async (file, uploadResponse, permissions, genThumbs = false, variantSet = null) => {
  const { uploadURL } = uploadResponse;
  let requestBody = JSON.stringify(
    { 
      attachment: {
        id: uploadURL.substring(uploadURL.indexOf('files/')),
        storage: "cache",
        metadata: {
          filename: file.name,
          size: file.size,
          mime_type: file.type,
        }
      },
      permissions: permissions,
      genThumbs: genThumbs,
      variantSet: variantSet
    }
  );
  let path = attachment_finalize_path({_options: true});

  const response = await fetch(path, {...defaultOpts(), method: 'POST', body: requestBody})
  if (!response.ok){
    return {
      status: response.status,
      file,
      error: response.statusText
    }
  }
  return await response.json();
}

// logo attachments
export const finalizeLogoUpload = async (file, uploadResponse, permissions, logoOptions = {}) => {
  const { uploadURL } = uploadResponse;
  let requestBody = JSON.stringify(
    { 
      attachment: {
        id: uploadURL.substring(uploadURL.indexOf('files/')),
        storage: "cache",
        metadata: {
          filename: file.name,
          size: file.size,
          mime_type: file.type,
        }
      },
      permissions: permissions
    }
  );
  let path = attachment_finalize_logo_path({_options: true});

  const response = await fetch(path, {...defaultOpts(), method: 'POST', body: requestBody})
  if (!response.ok){
    return {
      status: response.status,
      file,
      error: response.statusText
    }
  }
  return await response.json();
}
